module.exports = __webpack_public_path__ + "img/word.1fd15781.png";